import {Directive, ElementRef, Input, OnChanges, OnInit, NgModule} from '@angular/core';
import * as $ from 'jquery';

@Directive({selector: '[floating-label]'})
export class FloatingLabel implements OnInit {

    constructor(private element: ElementRef) {
    }

    private floatLabel(targetHtml: Element) {
        var input = $(targetHtml);
        // cambio input as string
        if ($.trim(input.val() as string) !== '') {
            input.addClass('dirty').removeClass('static');
        } else {
            input.removeClass('dirty').removeClass('static');
        }
    }

    ngOnInit() {
        let targetHtml: JQuery = $(this.element.nativeElement).find(".form-control");
        targetHtml.bind('keyup change', (event) => {
            this.floatLabel(event.currentTarget);
        });

        this.floatLabel(targetHtml[0]);
    }
}

@NgModule({
    declarations: [FloatingLabel],
    exports: [FloatingLabel]
})
export class FloatingLabelModule {

}
